import { carouselData } from '@/mocks/comics';

const colorStyles: Record<string, { tag: string; accent: string }> = {
  accent: { tag: 'bg-accent-500', accent: 'from-accent-500/30' },
  primary: { tag: 'bg-primary-500', accent: 'from-primary-500/30' },
  secondary: { tag: 'bg-secondary-500', accent: 'from-secondary-500/30' },
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            重磅推荐
          </h2>
          <p className="text-sm text-foreground-500">
            编辑精选的优质漫画专题合集
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselData.map((item) => {
            const styles = colorStyles[item.color];
            return (
              <a
                key={item.id}
                href="#carousel"
                className="group relative rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all cursor-pointer aspect-[16/10]"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${styles.accent} via-transparent to-transparent`}></div>
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>

                <div className="absolute top-3 left-3">
                  <span className={`inline-block text-xs font-medium text-white ${styles.tag} px-3 py-1 rounded-full`}>
                    {item.tag}
                  </span>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold text-white mb-1.5 line-clamp-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-white/80 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}